module.exports = __webpack_public_path__ + "img/checked-primary.d348bf93.svg";